export default __webpack_public_path__ + "static/media/salma.e86201c2.png";